import { mergeClasses } from '../helpers/styling'
import { ButtonLink } from './basic/Button'
import styles from './login/LoginPageLayout.module.css'
import logo from '../images/wistor-mark-color.svg'
import { PlatformConfigationTopBar } from './ConfigurationTopBar'
import { useWistorAuth } from '../api/auth'
import { Icon } from './widgets/Icon'
import React from 'react'
import { AnimatedWistorLogo } from './AnimatedWistorLogo'
import { createPortal } from 'react-dom'

export function SingleLoginUnauthorizedView(props: {
  error: 'FORBIDDEN'
  projectPath: string
}) {
  const auth = useWistorAuth()

  const message = auth.status === 'authorized'
    ? `${auth.user.email} is not allowed to access this application.`
    : "Something went unexpectedly wrong. Contact support if this keeps occuring."

  return (
    <div className="size-full">
      {!window.CONNECTED_APPS_STATIC && (
        <PlatformConfigationTopBar projectPath={props.projectPath} />
      )}
      <div className="size-full flex flex-col justify-around items-center bg-[#eaeaea]">
        <div className={"py-8 px-10 rounded-md bg-red-200 text-red-950 flex gap-4 items-center"}>
          <Icon icon="triangle-exclamation" className="text-4xl" />
          <div className="font-medium w-full">{message}</div>
        </div>
      </div>
    </div>
   )
}


export function SingleLoginButton() {
  return (
    <SingleUserButton href="/rest/oidc/login">
      Login via login.wistor.nl
    </SingleUserButton>
  )
}

export function SingleLogoutButton() {
  return (
    <SingleUserButton href="/rest/oidc/logout">
      Logout of login.wistor.nl
    </SingleUserButton>
  )
}

function SingleUserButton(props: { href: string, children: React.ReactNode }) {
  const [visibleOverlay, setVisibleOverlay] = React.useState(false)

  return (
    <>
      <ButtonLink
        variant="outline"
        className={mergeClasses(styles['login-button-sso'], "w-full mt-4")}
        href={props.href}
        onClick={() => setVisibleOverlay(true)}
      >
        <img src={logo} alt="wistor logo" />
        <span>{props.children}</span>
      </ButtonLink>
      {visibleOverlay && createPortal((
        <div className="fixed inset-0 bg-opacity-55 backdrop-blur-md bg-slate-600 flex flex-col justify-around items-center rounded-xl">
          <AnimatedWistorLogo />
        </div>
      ), document.body)}
    </>
  )
}
